import { AlertCircle } from "lucide-react";
import { Button } from "~/components/ui/button";
import { useIsAgencyClient, useTeamAgency } from "~/hooks/useTeamAccess";
import { billingPath } from "~/lib/billing-paths";
import { Link } from "~/lib/team-router";

export default function PastDueNotice() {
  const teamAgency = useTeamAgency();
  const isAgencyClient = useIsAgencyClient();
  return (
    <div className="mx-auto max-w-lg rounded-lg border border-red-200 bg-white p-5 shadow-sm">
      <div className="mb-4 flex h-10 w-10 items-center justify-center rounded-lg border border-red-200 bg-red-50">
        <AlertCircle className="h-5 w-5 text-red-700" />
      </div>

      <h3 className="text-xl font-semibold text-stone-900">Payment failed</h3>

      <p className="pt-2 text-sm text-stone-500">
        {isAgencyClient
          ? "We could not charge the card for this workspace. Contact your agency to restore access."
          : "We could not charge the card for this workspace. Update your payment method to keep using Zerply."}
      </p>

      {!isAgencyClient && (
        <Button asChild className="mt-5 w-full bg-orange-500 text-white hover:bg-orange-600">
          <Link to={billingPath(Boolean(teamAgency))}>Update payment</Link>
        </Button>
      )}
    </div>
  );
}
